import React from 'react';
import PackageSearchGridItem from './PackageSearchGridItem';

const PackageSearchGrid = (props) => {
    return (
        <div className="land-search-grid">
            <div className="cf">
                {props.data.map((thisPackage) =>
                    <PackageSearchGridItem key={thisPackage.id} data={thisPackage} />
                )}
            </div>
        </div>
    );
};

export default PackageSearchGrid;


/** WEBPACK FOOTER **
 ** ./src/modules/house-and-land/elements/PackageSearchGrid.js
 **/